import { fetchMPFilters } from "api/bookingOrder"
import {
  MediaTypeChannel,
  MediaTypeFilters,
  MediaTypeVendor,
} from "models/bookingOrder"
import { useQuery } from "react-query"

const TUPLE_ID_SEPARATOR = "/"

function getVendorOptionValue(vt: MediaTypeVendor) {
  const mediaOwnerId = vt.mediaOwner.id
  const intermediaryId = vt.intermediary?.id
  const value = intermediaryId
    ? [mediaOwnerId, intermediaryId].join(TUPLE_ID_SEPARATOR)
    : mediaOwnerId

  return value
}

export function getVendorOptionLabel(vt: MediaTypeVendor) {
  return `${vt.mediaOwner.name}${
    vt?.intermediary ? ` / ${vt.intermediary.name}` : ""
  }`
}

export function getVendorTupleOption(vt: MediaTypeVendor) {
  return { name: getVendorOptionLabel(vt), code: getVendorOptionValue(vt) }
}

function getVPOptionValue(vt: MediaTypeChannel) {
  const mediaOwnerId = vt.mediaOwner.id
  const intermediaryId = vt.intermediary?.id
  const supplierProductId = vt.id
  const value = intermediaryId
    ? [mediaOwnerId, intermediaryId, supplierProductId].join(TUPLE_ID_SEPARATOR)
    : [mediaOwnerId, supplierProductId].join(TUPLE_ID_SEPARATOR)

  return value
}

export function getVPOptionLabel(vt: MediaTypeChannel) {
  return `${vt.name} (${vt.mediaOwner.name}${
    vt?.intermediary ? `/ ${vt.intermediary.name}` : ""
  })`
}

export function getVendorProductTupleOption(vt: MediaTypeChannel) {
  return { name: getVPOptionLabel(vt), code: getVPOptionValue(vt) }
}

export function useMPFilters(isEnabled: boolean, planId?: string) {
  const { data: mpFilters } = useQuery(
    ["mediaPlan-filters", planId || ""],
    fetchMPFilters,
    {
      enabled: isEnabled,
      refetchOnMount: !!planId,
    },
  )
  const hasNoOptions = Object.keys(mpFilters ?? {}).every(
    (filter) => !mpFilters?.[filter as keyof MediaTypeFilters]?.length,
  )
  return { mpFilters, hasNoOptions }
}
